import { Slider } from 'antd';
import { styled } from 'styled-components';

export const StyledRangeSLider = styled(Slider)`
  .ant-slider-track {
    background-color: ${props => props.theme.colors?.info?.main?.filled} !important;
  }
  .ant-slider-handle::after {
    background-color: ${props => props.theme.colors?.info?.main?.filled} !important;
    box-shadow: 0 0 0 2px ${props => props.theme.colors?.info?.main?.filled} !important;
  }
`;
